import React from 'react';
import { getAuthorVoiceLabel } from '../../../utils/childChapterUtils';

/**
 * Small badge showing who writes for this chapter.
 *
 * Props:
 *   authorVoice - one of 'guardian_only', 'guardian_primary', 'mixed', 'child_leads'
 */
function GuardianBadge({ authorVoice }) {
  const { label, icon } = getAuthorVoiceLabel(authorVoice);

  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-medium bg-[#556B2F]/10 text-[#556B2F]">
      <span>{icon}</span>
      <span>{label}</span>
    </span>
  );
}

export default GuardianBadge;
